import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MenuFacade } from '../menu/data-access/facades/menu.facade';

export const redirectToFirstModuleGuard: CanActivateFn = () => {
  const menuFacade = inject(MenuFacade);
  const router = inject(Router);

  const target = menuFacade.firstAvailableRoute();

  return target ? router.parseUrl(target) : router.parseUrl('/sin-secciones');
};
